<template>
    <div class="mt-2">
        <label for="body" class="text-sm font-bold block p-1">Email Body</label>
        <textarea id="body" v-model="variables.body" rows="4" class="border border-gray-dark relative rounded-md shadow-sm w-full outline-none p-2" placeholder="What should be sent as reply?"></textarea>
    </div>
</template>

<script>
export default {
    data() {
        return {
            name: 'reply',
            variables: {
                body: '',
            },
        }
    },
    mounted() {
        this.syncData();
    },
    watch: {
        $data: {
            handler() {
                this.syncData();
            },
            deep: true,
        }
    },
    methods: {
        syncData() {
            this.$emit('change', {
                name     : this.name,
                variables: this.variables,
            });
        }
    }
}
</script>

<style>

</style>